import { ReactNode } from "react";
import { FixaText } from "@coworker/apprestructured/src/shared/wrappers/FixaText/FixaText";

function Name({ children }: { children: ReactNode }) {
  return (
    <FixaText tagName="h3" textStyle="Heading.L">
      {children}
    </FixaText>
  );
}

export default Name;
